import React, {Fragment, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
    clientStatusEnums,
    FindLoad,
    FindSuccessItem,
    Images,
    PermissionList,
    renderClientName,
    renderFirstLetters,
    RolePermission,
    tagEnums
} from 'utils';
import {
    NameAndAvatar,
    UserInputsDropdown,
    TagComponent,
    NavigateCalendar,
    MinLoader, PhoneBadge, EmailBadge, BadgeLine,
} from 'components';
import {CLIENT_STATUSES} from './constants';
import {appointmentActions, clientActions, httpRequestsOnSuccessActions, systemActions} from 'store';
import {Eligibility} from '../../../schedule/core/common';

const STATUS_ACTION_TYPE = 'EDIT_CLIENT_STATUS';
const CHECK_ACTION_TYPE = 'CHECK_ELIGIBILITY';

export const TabsHeader = ({data}) => {
    const client = useSelector((state) => state.client.clientItemInfo);
    const canUseIntegrations = useSelector((state) => state.system.canUseIntegrations);
    const dispatch = useDispatch();
    const loadEligibility = FindLoad(CHECK_ACTION_TYPE);
    const eligibilitySuccess = FindSuccessItem(CHECK_ACTION_TYPE);

    useEffect(() => {
        if (eligibilitySuccess) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(CHECK_ACTION_TYPE));
            dispatch(clientActions.getClientsById(client?.id, 'noload'));
        }
    }, [eligibilitySuccess]);

    useEffect(() => {
        if (RolePermission([PermissionList.ELIGIBILITY_CHECK?.code])) {
            dispatch(systemActions.canUseIntegration());
        }
    }, []);

    const handleChangeStatus = (params) => {
        dispatch(clientActions.editClientStatus(client?.id, params));
    };

    const handleCheckEligibility = () => {
        dispatch(appointmentActions.checkEligibility(data?.id));
    };

    return (
        <Fragment>
            <div className="tabs-wrapper">
                <div className="full-width">
                    <div className="space-between-flex-start">

                        <NameAndAvatar
                            src={data?.avatar?.url}
                            name={renderClientName(data)}
                            nameSuffix={
                                client?.eligibilityCheck && (
                                    <Eligibility info={client} payerName={client?.enrollment} fromClient={true}/>
                                )
                            }
                            initials={renderFirstLetters(data)}
                        >
                            <div className='flex-align-center' style={{gap: 12}}>
                                {data?.phoneNumber &&
                                    <PhoneBadge phone={data?.phoneNumber}/>
                                }
                                {data?.email &&
                                    <EmailBadge email={data?.email}/>
                                }

                                <BadgeLine/>

                                <TagComponent
                                    userInfo={client}
                                    module={tagEnums.CLIENT}
                                    singleView
                                    doNotCropTags
                                    maxTags={null}
                                    notSetText={'No tags added'}
                                />
                            </div>
                        </NameAndAvatar>

                        <div className="flex-align-start" style={{gap: 16}}>
                            {RolePermission([PermissionList.ELIGIBILITY_CHECK?.code]) &&
                                canUseIntegrations?.activeTlClearinghouse &&
                                client?.enrollment && (
                                    <>
                                        <button
                                            className="check-client-eligibility-btn"
                                            onClick={(e) => {
                                                handleCheckEligibility(e);
                                            }}
                                        >
                                            {loadEligibility?.length ? (
                                                <MinLoader
                                                    width={'18px'}
                                                    height={'18px'}
                                                    margin={'0'}
                                                    color={'#414651'}
                                                    position={'relative'}
                                                />
                                            ) : (
                                                <img src={Images.userCheckEligibility} alt="icon"/>
                                            )}
                                            <p>Check Eligibility</p>
                                        </button>
                                    </>
                                )}

                            <NavigateCalendar client={data} full={true}/>
                            {RolePermission([PermissionList.CLIENT_STATUS?.code]) && (
                                <UserInputsDropdown
                                    dropdownOptions={client?.status === clientStatusEnums.INVITED ? CLIENT_STATUSES : CLIENT_STATUSES?.filter((i) => i?.id !== clientStatusEnums.INVITED)}
                                    actionType={STATUS_ACTION_TYPE}
                                    selected={data?.status}
                                    onPass={handleChangeStatus}
                                    type={'Client'}
                                    disableRow={(type) => type?.id === clientStatusEnums.INVITED}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};
